import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch} from '@fortawesome/free-solid-svg-icons'

import '../AddChild/AddChild.css';



let childer = [];

class ChangeChildDetails extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      childNo:'',
      childName:'',
      childSurname:'',
      childClass:'',
      allergies:[],
      allergy:'',
      childGender:'',
      collector1No:'',
      collector1Rel:'',
      col1mon:false,
      col1tue:false,
      col1wed:false,
      col1thu:false,
      col1fri:false,
      collector2No:'',
      collector2Rel:'',
      col2mon:false,
      col2tue:false,
      col2wed:false,
      col2thu:false,
      col2fri:false,
      collector3No:'',
      collector3Rel:'',
      col3mon:false,
      col3tue:false,
      col3wed:false,
      col3thu:false,
      col3fri:false,
      collector4No:'',
      collector4Rel:'',
      col4mon:false,
      col4tue:false,
      col4wed:false,
      col4thu:false,
      col4fri:false,
      part2:false,
      data:[],
      sclasses:[],
      showNxt:false,
      childCat:'',
      searchShow:'searchHide',
      colNo1phone:'',
      colNo2phone:'',
      colNo3phone:'',
      colNo4phone:'',
      colNo1:'',
      colNo2:'',
      colNo3:'',
      colNo4:'',
      colSearch:[],
      Colnumber:0,
      searchSurname:'',
      searchName:'',
      childSchoolID:'',
    }
  }


  componentDidMount(){


    fetch('https://schoolportal.appsdesign.co.za/get_child/' + localStorage.getItem('schoolToken'))
    .then((response) => response.json())
    .then((responseJson) => {
  console.log(responseJson[0])
      this.setState({
        data: responseJson,

  }, function(){

      });
console.log(this.state.data)
    })
    .catch((error) =>{
      console.error(error);
    });


    fetch('https://schoolportal.appsdesign.co.za/get_class/' + localStorage.getItem('schoolToken'))
    .then((response) => response.json())
    .then((responseJson) => {
    console.log(responseJson[0])
      this.setState({
        sclasses: responseJson,

    }, function(){

      });
    console.log(this.state.sclasses)
    })
    .catch((error) =>{
      console.error(error);
    });



    fetch('https://schoolportal.appsdesign.co.za/school_collector/' + localStorage.getItem('schoolToken'))
    .then((response) => response.json())
    .then((responseJson) => {
    console.log(responseJson[0])
      this.setState({
        colSearch: responseJson,

    }, function(){

      });
    console.log(this.state.colSearch)
    })
    .catch((error) =>{
      console.error(error);
    });



    }

    onSearchName = (e) =>{

      this.setState({searchName:e.target.value}, function(){
        console.log('name changed')
      })
    }



    onSearchSurname = (e) =>{

      this.setState({searchSurname:e.target.value}, function(){
        console.log('name changed')
      })
    }



deleteChild = (val) =>{
  fetch('https://schoolportal.appsdesign.co.za/delete_child/' + val)
  .then(() => {
  alert('child data has been deleted')
  })
  .catch((error) =>{
    console.error(error);
  });

  }












      setCol1mon = () =>{
         this.setState(
           { col1mon: !this.state.col1mon },
           function(){
           console.log(this.state.col1mon);
         });

    }


      setCol1tue = () =>{
         this.setState(
           { col1tue: !this.state.col1tue },
           function(){
           console.log(this.state.col1tue);
         });

    }
    setCol1wed = () =>{
       this.setState(
         { col1wed: !this.state.col1wed },
         function(){
         console.log(this.state.col1wed);
       });

    }


    setCol1thu = () =>{
       this.setState(
         { col1thu: !this.state.col1thu },
         function(){
         console.log(this.state.col1thu);
       });

    }



    setCol1fri = () =>{
       this.setState(
         { col1fri: !this.state.col1fri },
         function(){
         console.log(this.state.col1fri);
       });

    }




      setCol2mon = () =>{
         this.setState(
           { col2mon: !this.state.col2mon },
           function(){
           console.log(this.state.col2mon);
         });

    }


      setCol2tue = () =>{
         this.setState(
           { col2tue: !this.state.col2tue },
           function(){
           console.log(this.state.col2tue);
         });

    }
    setCol2wed = () =>{
       this.setState(
         { col2wed: !this.state.col2wed },
         function(){
         console.log(this.state.col2wed);
       });

    }


    setCol2thu = () =>{
       this.setState(
         { col2thu: !this.state.col2thu },
         function(){
         console.log(this.state.col2thu);
       });

    }



    setCol2fri = () =>{
       this.setState(
         { col2fri: !this.state.col2fri },
         function(){
         console.log(this.state.col2fri);
       });

    }




      setCol3mon = () =>{
         this.setState(
           { col2mon: !this.state.col2mon },
           function(){
           console.log(this.state.col2mon);
         });

    }


      setCol3tue = () =>{
         this.setState(
           { col3tue: !this.state.col3tue },
           function(){
           console.log(this.state.col3tue);
         });

    }
    setCol3wed = () =>{
       this.setState(
         { col3wed: !this.state.col3wed },
         function(){
         console.log(this.state.col3wed);
       });

    }


    setCol3thu = () =>{
       this.setState(
         { col3thu: !this.state.col3thu },
         function(){
         console.log(this.state.col3thu);
       });

    }



    setCol3fri = () =>{
       this.setState(
         { col3fri: !this.state.col3fri },
         function(){
         console.log(this.state.col3fri);
       });

    }


      setCol4mon = () =>{
         this.setState(
           { col4mon: !this.state.col4mon },
           function(){
           console.log(this.state.col4mon);
         });

    }


      setCol4tue = () =>{
         this.setState(
           { col4tue: !this.state.col4tue },
           function(){
           console.log(this.state.col4tue);
         });

    }
    setCol4wed = () =>{
       this.setState(
         { col4wed: !this.state.col4wed },
         function(){
         console.log(this.state.col4wed);
       });

    }


    setCol4thu = () =>{
       this.setState(
         { col4thu: !this.state.col4thu },
         function(){
         console.log(this.state.col4thu);
       });

    }



    setCol4fri = () =>{
       this.setState(
         { col4fri: !this.state.col4fri },
         function(){
         console.log(this.state.col4fri);
       });

    }




    changeChildSchoolID = (event) =>{

    this.setState({childSchoolID:event.target.value});

    }

    changeChildCategory = (event) =>{

    this.setState({childCat:event.target.value});

    }

    changeChildName = (event) =>{

    this.setState({childName:event.target.value});

    }

    changeChildSurname = (event) =>{

    this.setState({childSurname:event.target.value});




    }


    changeAllergy = (event) =>{


    this.setState({allergy:event.target.value});

    }

    changeChildAllergy = () =>{
    var allergy = this.state.allergies;

    allergy.push(this.state.allergy)

    this.setState({allergies:allergy}, function(){

      console.log(this.state.allergies)
    });

    }

    removeChildAllergy = (val) =>{

    var allergy = this.state.allergies;


      allergy.splice(val);


    this.setState({allergies:allergy}, function(){

      console.log(this.state.allergies)
    });

    }






    changeChildClass = (event) =>{

    this.setState({childClass:event.target.value});

    }

    changeChildGender = (event) =>{

    this.setState({childGender:event.target.value});

    }

    changeCollector1No = (event) =>{

    this.setState({collector1No:event.target.value});

    }
    changeCollector2No = (event) =>{

    this.setState({collector2No:event.target.value});

    }

    changeCollector3No = (event) =>{

    this.setState({collector3No:event.target.value});

    }
    changeCollector4No = (event) =>{

    this.setState({collector4No:event.target.value});

    }



    changeCollector1Rel = (event) =>{

    this.setState({collector1Rel:event.target.value});

    }


    changeCollector2Rel = (event) =>{

    this.setState({collector2Rel:event.target.value});

    }


    changeCollector3Rel = (event) =>{

    this.setState({collector3Rel:event.target.value});

    }

    changeCollector4Rel = (event) =>{

    this.setState({collector4Rel:event.target.value});

    }






changeToPart2 = () =>{

    this.setState({
      part2:true,
      showNxt:true

    });

this.state.data.map(val =>{

  if (val.childname.toLowerCase().includes(this.state.childName.toLowerCase()) && val.childsurname.toLowerCase().includes(this.state.childSurname.toLowerCase())){

    this.setState({
      childNo:val._id,
      childSchoolID:val.schoolID,
      childName:val.childname,
      childSurname:val.childsurname,
      allergies:val.allergies,
      childClass:val.childclass,
      childGender:val.childgender,
      collector1No:val.collectors[0].code,
      colNo1:val.collectors[0].code,
      collector1Rel:val.collectors[0].rel,
      colNo1phone:val.collectors[0].phone,
      col1mon:val.collectors[0].allowed[0],
      col1tue:val.collectors[0].allowed[1],
      col1wed:val.collectors[0].allowed[2],
      col1thu:val.collectors[0].allowed[3],
      col1fri:val.collectors[0].allowed[4],
      collector2No:val.collectors[1].code,
      colNo2:val.collectors[1].code,
      collector2Rel:val.collectors[1].rel,
      colNo2phone:val.collectors[1].phone,
      col2mon:val.collectors[1].allowed[0],
      col2tue:val.collectors[1].allowed[1],
      col2wed:val.collectors[1].allowed[2],
      col2thu:val.collectors[1].allowed[3],
      col2fri:val.collectors[1].allowed[4],
      collector3No:val.collectors[2].code,
      colNo3:val.collectors[2].code,
      collector3Rel:val.collectors[2].rel,
      colNo3phone:val.collectors[2].phone,
      col3mon:val.collectors[2].allowed[0],
      col3tue:val.collectors[2].allowed[1],
      col3wed:val.collectors[2].allowed[2],
      col3thu:val.collectors[2].allowed[3],
      col3fri:val.collectors[2].allowed[4],
      collector4No:val.collectors[3].code,
      colNo4:val.collectors[3].code,
      collector4Rel:val.collectors[3].rel,
      colNo4phone:val.collectors[3].phone,
      col4mon:val.collectors[3].allowed[0],
      col4tue:val.collectors[3].allowed[1],
      col4wed:val.collectors[3].allowed[2],
      col4thu:val.collectors[3].allowed[3],
      col4fri:val.collectors[3].allowed[4],

    });


  }





return false;

})




}

changeCancel = () =>{

this.setState({part2:false});



}



updateChild = () =>{
  if(this.state.childSchoolID === ''){

      alert(`please add the child's ID `);
    }
    else{
                alert(`Updated child details \n\r
                       Child no: ${this.state.childNo} \n\r
                       Child name: ${this.state.childName} \n\r
                       Child surname: ${this.state.childSurname} \n\r
                       Child class: ${this.state.childClass} \n\r
                       Child gender: ${this.state.childGender} \n\r
                       Collector 1 No: ${this.state.collector1No} \n\r
                       Collector 2 No: ${this.state.collector2No} \n\r
                       Collector 3 No: ${this.state.collector3No} \n\r
                       Collector 4 No: ${this.state.collector4No} \n\r
                       `)
                       fetch('https://schoolportal.appsdesign.co.za/update_child', {
                           method: 'post',
                           headers: {'Content-Type' : 'application/json'},
                           body: JSON.stringify({

                        childno: this.state.childNo,
                        schoolID:this.state.childSchoolID,
                        childSchool:localStorage.getItem('schoolToken'),
                        schoolabv:localStorage.getItem('schoolAbv'),
                        pnum: localStorage.getItem('schoolphone'),
                        childname: this.state.childName,
                        childsurname: this.state.childSurname,
                        allergies:this.state.allergies,
                        childclass: this.state.childClass,
                        childgender: this.state.childGender,
                        category:this.state.childCat,
                        dateupdated: new Date().toString(),
                        childcomments: "test comment",
                        collector1vcode: this.state.collector1No,
                        collector1rel:this.state.collector1Rel,
                        phone1:this.state.colNo1phone,
                        collector1allowed: [this.state.col1mon, this.state.col1tue, this.state.col1wed, this.state.col1thu, this.state.col1fri],
                        collector2vcode: this.state.collector2No,
                        collector2rel:this.state.collector2Rel,
                        phone2:this.state.colNo2phone,
                        collector2allowed: [this.state.col2mon, this.state.col2tue, this.state.col2wed, this.state.col2thu, this.state.col2fri],
                        collector3code: this.state.collector3No,
                        collector3rel:this.state.collector3Rel,
                        phone3:this.state.colNo3phone,
                        collector3allowed: [this.state.col3mon, this.state.col3tue, this.state.col3wed, this.state.col3thu, this.state.col3fri],
                        collector4code: this.state.collector4No,
                        collector4rel:this.state.collector4Rel,
                        phone4:this.state.colNo4phone,
                        collector4allowed: [this.state.col4mon, this.state.col4tue, this.state.col4wed, this.state.col4thu, this.state.col4fri],
                        absent: false,
                        collected: false

                     })
                       })
                       .then(response =>{
                         this.setState({

                           part2:false,
                           showNxt:false,

                         }, function(){alert('Child has been updated') })


                      })


}
}


searchCol = (val) =>{

this.setState({
  searchShow:'searchShow',
   Colnumber:val,

},function(){
  console.log(this.state.Colnumber);
})


}

setColNo = (val, cell) =>{

if(this.state.Colnumber === 1){
this.setState({
  searchShow:'searchHide',
  colNo1:val,
  collector1No:val,
  colNo1phone:cell,
}, function(){
  console.log('Collector added with: '+this.state.colNo1);
})
}
else if(this.state.Colnumber === 2){
this.setState({
  searchShow:'searchHide',
  colNo2:val,
  collector2No:val,
  colNo2phone:cell,
})
}

else if(this.state.Colnumber === 3){
this.setState({
  searchShow:'searchHide',
  colNo3:val,
  collector3No:val,
  colNo3phone:cell,
})
}

else if(this.state.Colnumber === 4){
this.setState({
  searchShow:'searchHide',
  colNo4:val,
  collector4No:val,
  colNo4phone:cell,
})
}


}




render(){


  const schoolclasses = this.state.sclasses.map((schoolclass, i) => {

  return(

    <option key={i} value={schoolclass.assClass}>{schoolclass.assClass}</option>
  )


  });


  const als = this.state.allergies.map((val,i) =>{

    return <div style={{display: 'flex', justifyContent:'space-between', border:'1px solid black'}}><span style={{color:'black', fontWeight:'bold'}}>{val}</span> <button onClick={() => this.removeChildAllergy(i)}>&times;</button></div>
  })


let child;

if(this.state.part2 && this.state.showNxt){
console.log(childer);
  child = this.state.data.map( (child,i) => {
console.log(child);

var childfname = child.childname +' '+ child.childsurname;
var checkfname = this.state.childName.toLowerCase() +' '+ this.state.childSurname.toLowerCase();

    if (childfname.toLowerCase().includes(checkfname)){

var categ = child.category === 'W' ? 'Waiting class' : (child.category === 'A' ? 'After care' :(child.category === 'H' ? 'Half day' : child.category === 'F' ? 'Full day' : (child.category === 'S' ? 'School': 'School')))


  return (

<div key={i} className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100 ,backgroundColor:'white'}}>
    <h1>Change Child Details</h1>
  <div style={{display:'flex', flexDirection:'column',justifyContent:'space-evenly', border:'1px solid black' , padding:20, margin:10}}>


  <label htmlFor="childsid" style={{marginRight:21}}>
  Child ID
  <input
  type="text"
  defaultValue={child.schoolID}
  id="childsid"
  className="pa2 ma2"
  onKeyUp={this.changeChildSchoolID}
  /></label>
  <br/>


  <label htmlFor="childCategory">
  Child Category
  <select
  id="childCategory"
  className="pa2 ma2"
  onChange={this.changeChildCategory}
  >
  <option value={child.category}>{categ}</option>
  <option value="W">Waiting class</option>
    <option value="A">After care</option>
      <option value="H">Half day</option>
      <option value="F">Full day</option>
        <option value="S"> School</option>

      </select>
  </label><br/>

  <label htmlFor="childName" style={{marginRight:21}}>
  Child Name
  <input
  type="text"
  placeholder="Child Name"
  id="childName"
  defaultValue={child.childname}
  className="pa2 ma2"
  onKeyUp={this.changeChildName}
  /></label>
  <br/>

  <label htmlFor="childSurname">
  Child Surname
  <input
  type="text"
  placeholder="Child Surname"
  id="childSurname"
  defaultValue={child.childsurname}
  className="pa2 ma2"
  onKeyUp={this.changeChildSurname}
  />
  </label><br/>



    <div>
    <h3>Allergies:</h3>
      <label htmlFor="childAllergy">
      Add Allergy
      <input
      type="text"
      placeholder="Add Child Allergy"
      id="childAllergy"
      className="pa2 ma2"
      onKeyUp={this.changeAllergy}
      />
      </label>
    <button onClick={this.changeChildAllergy}> + </button><br/>
    <div style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', border:'1px solid black'}}>
    {als}
    </div>
    </div>





  <label htmlFor="childClass">
  Child Class
  <select
  id="childClass"
  defaultValue={child.childclass}
  className="pa2 ma2"
  onChange={this.changeChildClass}
  >
  <option value={child.childclass}>{child.childclass}</option>
  {schoolclasses}
        </select>

  </label><br/>

  <label htmlFor="childGender">
    Child Gender
  <select
  id="childGender"
  className="pa2 ma2"
  defaultValue={child.childgender}
  onChange={this.changeChildGender}
    >
  <option value="">Please select</option>
    <option value="male">Male</option>
      <option value="female">Female</option>
        <option value="other">Other</option>
        </select>
    </label><br/>




</div>


    <div style={{border:'1px solid black' , padding:20, margin:10}}>




          <label htmlFor="collector1No">
          Collector 1 No<br/>
          <button onClick={() => this.searchCol(1)} style={{border:'1px solid black', backgroundColor:'white'}}>
          search<FontAwesomeIcon icon={faSearch} />
          </button>
        <input
        type="text"
        value={this.state.colNo1 === '' && child.collectors[0] !== undefined ? child.collectors[0].code : this.state.colNo1}
        id="collector1No"
        className="pa2 ma2"
        onChange={this.changeCollector1No}
        />
          </label><br/>




       <label htmlFor="collector1Rel">
        Relationship
       <select
       id="collector1Rel"
       className="pa2 ma2"
       onChange={this.changeCollector1Rel}
       >
       <option value={child.collectors[0].rel}>{child.collectors[0].rel}</option>
       <option value="Mother">Mother</option>

       <option value="Father">Father</option>

       <option value="Legal Guardian">Legal Guardian</option>

       <option value="Family Member">Family Member</option>

       <option value="Friend">Friend</option>

       <option value="Shuttle Driver">Shuttle Driver</option>

           </select>
       </label><br/>



    <h4>Allowed days</h4>
    <label htmlFor="col1mon" style={{margin:5}}>
    Monday
    <input type="checkbox" id="col1mon" defaultChecked={child.collectors[0].allowed[0]} onClick={this.setCol1mon}/>
    </label>


    <label htmlFor="col1tue" style={{margin:5}}>
    Tuesday
    <input type="checkbox" id="col1tue" defaultChecked={child.collectors[0].allowed[1]} onClick={this.setCol1tue}/>
    </label> &nbsp;


    <label htmlFor="col1wed" style={{margin:5}}>
    Wednesday
    <input type="checkbox" id="col1wed" defaultChecked={child.collectors[0].allowed[2]} onClick={this.setCol1wed}/>
    </label> &nbsp;



    <label htmlFor="col1thu" style={{margin:5}}>
    Thursday
    <input type="checkbox" id="col1thu" defaultChecked={child.collectors[0].allowed[3]}  onClick={this.setCol1thu}/>
    </label> &nbsp;


    <label htmlFor="col1fri" style={{margin:5}}>
    Friday
    <input type="checkbox" id="col1fri" defaultChecked={child.collectors[0].allowed[4]} onClick={this.setCol1fri}/>
    </label>


    </div>



        <div style={{border:'1px solid black' , padding:20, margin:10}}>



          <label htmlFor="collector2No">
          Collector 2 No<br/>
          <button onClick={() => this.searchCol(2)} style={{border:'1px solid black', backgroundColor:'white'}}>
          search<FontAwesomeIcon icon={faSearch} />
          </button>
        <input
        type="text"
        value={this.state.colNo2 === '' && child.collectors[1] !== undefined ? child.collectors[1].code : this.state.colNo2}
        id="collector2No"
        className="pa2 ma2"
        onChange={this.changeCollector2No}
        />
          </label><br/>







          <label htmlFor="collector2Rel">
           Relationship
          <select
          id="collector2Rel"
          className="pa2 ma2"
          onChange={this.changeCollector2Rel}
          >
          <option value={child.collectors[1] !== undefined ? child.collectors[1].rel : ""}>{child.collectors[1] !== undefined ? child.collectors[1].rel : ""}</option>
          <option value="Mother">Mother</option>

          <option value="Father">Father</option>

          <option value="Legal Guardian">Legal Guardian</option>

          <option value="Family Member">Family Member</option>

          <option value="Friend">Friend</option>

          <option value="Shuttle Driver">Shuttle Driver</option>

              </select>
          </label><br/>



    <h4>Allowed days</h4>
    <label htmlFor="col2mon" style={{margin:5}}>
    Monday
    <input type="checkbox" id="col2mon" defaultChecked={child.collectors[1].allowed[0]} onClick={this.setCol2mon}/>
    </label>


    <label htmlFor="col2tue" style={{margin:5}}>
    Tuesday
    <input type="checkbox" id="col2tue" defaultChecked={child.collectors[1].allowed[1]} onClick={this.setCol2tue}/>
    </label> &nbsp;


    <label htmlFor="col2wed" style={{margin:5}}>
    Wednesday
    <input type="checkbox" id="col2wed" defaultChecked={child.collectors[1].allowed[2]}  onClick={this.setCol2wed}/>
    </label> &nbsp;



    <label htmlFor="col2thu" style={{margin:5}}>
    Thursday
    <input type="checkbox" id="col2thu" defaultChecked={child.collectors[1].allowed[3]} onClick={this.setCol2thu}/>
    </label> &nbsp;


    <label htmlFor="col2fri" style={{margin:5}}>
    Friday
    <input type="checkbox" id="col2fri" defaultChecked={child.collectors[1].allowed[4]} onClick={this.setCol2fri}/>
    </label>


    </div>





    <div style={{border:'1px solid black' , padding:20, margin:10}}>



          <label htmlFor="collector3No">
          Collector 3 No<br/>
          <button onClick={() => this.searchCol(3)} style={{border:'1px solid black', backgroundColor:'white'}}>
          search<FontAwesomeIcon icon={faSearch} />
          </button>
        <input
        type="text"
        value={this.state.colNo3 === '' && child.collectors[2] !== undefined ? child.collectors[2].code : this.state.colNo3}
        className="pa2 ma2"
        onChange={this.changeCollector3No}
        />
          </label><br/>




       <label htmlFor="collector3Rel">
        Relationship
       <select
       id="collector3Rel"
       className="pa2 ma2"
       onChange={this.changeCollector3Rel}
       >
       <option value={child.collectors[2] !== undefined ? child.collectors[2].rel : ""}>{child.collectors[2] !== undefined ? child.collectors[2].rel : ""}</option>
       <option value="Mother">Mother</option>

       <option value="Father">Father</option>

       <option value="Legal Guardian">Legal Guardian</option>

       <option value="Family Member">Family Member</option>

       <option value="Friend">Friend</option>

       <option value="Shuttle Driver">Shuttle Driver</option>

           </select>
       </label><br/>



    <h4>Allowed days</h4>
    <label htmlFor="col3mon" style={{margin:5}}>
    Monday
    <input type="checkbox" id="col3mon" defaultChecked={child.collectors[2] !== undefined ? child.collectors[2].allowed[0] : false} onClick={this.setCol3mon}/>
    </label>


    <label htmlFor="col3tue" style={{margin:5}}>
    Tuesday
    <input type="checkbox" id="col3tue" defaultChecked={child.collectors[2] !== undefined ? child.collectors[2].allowed[1] : false} onClick={this.setCol3tue}/>
    </label> &nbsp;


    <label htmlFor="col3wed" style={{margin:5}}>
    Wednesday
    <input type="checkbox" id="col3wed" defaultChecked={child.collectors[2] !== undefined ? child.collectors[2].allowed[2] : false} onClick={this.setCol3wed}/>
    </label> &nbsp;



    <label htmlFor="col3thu" style={{margin:5}}>
    Thursday
    <input type="checkbox" id="col3thu" defaultChecked={child.collectors[2] !== undefined ? child.collectors[2].allowed[3] : false} onClick={this.setCol3thu}/>
    </label> &nbsp;


    <label htmlFor="col3fri" style={{margin:5}}>
    Friday
    <input type="checkbox" id="col3fri" defaultChecked={child.collectors[2] !== undefined ? child.collectors[2].allowed[4] : false} onClick={this.setCol13fri}/>
    </label>


    </div>





    <div style={{border:'1px solid black' , padding:20, margin:10}}>


          <label htmlFor="collector4No">
          Collector 4 No<br/>
          <button onClick={() => this.searchCol(4)} style={{border:'1px solid black', backgroundColor:'white'}}>
          search<FontAwesomeIcon icon={faSearch} />
          </button>
        <input
        type="text"
        value={this.state.colNo4 === '' && child.collectors[3] !== undefined ? child.collectors[3].code : this.state.colNo4}
        id="collector4No"
        className="pa2 ma2"
        onChange={this.changeCollector4No}
        />
          </label><br/>



       <label htmlFor="collector4Rel">
        Relationship
       <select
       id="collector4Rel"
       className="pa2 ma2"
       onChange={this.changeCollector4Rel}
       >
       <option value={child.collectors[3] !== undefined ? child.collectors[3].rel : ""}>{child.collectors[3] !== undefined ? child.collectors[3].rel : ""}</option>
       <option value="Mother">Mother</option>

       <option value="Father">Father</option>

       <option value="Legal Guardian">Legal Guardian</option>

       <option value="Family Member">Family Member</option>

       <option value="Friend">Friend</option>

       <option value="Shuttle Driver">Shuttle Driver</option>

           </select>
       </label><br/>





    <h4>Allowed days</h4>
    <label htmlFor="col4mon" style={{margin:5}}>
    Monday
    <input type="checkbox" id="col4mon" defaultChecked={child.collectors[3] !== undefined ? child.collectors[3].allowed[0] : false} onClick={this.setCol4mon}/>
    </label>


    <label htmlFor="col4tue" style={{margin:5}}>
    Tuesday
    <input type="checkbox" id="col4tue" defaultChecked={child.collectors[3] !== undefined ? child.collectors[3].allowed[1] : false} onClick={this.setCol4tue}/>
    </label> &nbsp;


    <label htmlFor="col4wed" style={{margin:5}}>
    Wednesday
    <input type="checkbox" id="col4wed" defaultChecked={child.collectors[3] !== undefined ? child.collectors[3].allowed[2] : false} onClick={this.setCol4wed}/>
    </label> &nbsp;



    <label htmlFor="col4thu" style={{margin:5}}>
    Thursday
    <input type="checkbox" id="col4thu" defaultChecked={child.collectors[3] !== undefined ? child.collectors[3].allowed[3] : false} onClick={this.setCol4thu}/>
    </label> &nbsp;


    <label htmlFor="col4fri" style={{margin:5}}>
    Friday
    <input type="checkbox" id="col4fri" defaultChecked={child.collectors[3] !== undefined ? child.collectors[3].allowed[4] : false} onClick={this.setCol4fri}/>
    </label>


    </div>



<div style={{margin:50}}>
    <button className="br3 pa3 bg-orange br-orange" onClick={this.changeCancel}>Cancel</button> &nbsp;
    <button className="br3 pa3 bg-red br-red" onClick={() => this.deleteChild(child._id)}>Delete</button> &nbsp;
    <button className="br3 pa3 bg-blue br-blue" onClick={this.updateChild}>Save</button>
</div>


</div>
  );

  }


return false;

  })



}




const searchResults = this.state.colSearch.map((collector,i) =>{

var colfname = collector.name.toLowerCase() +' '+collector.surname.toLowerCase();

if(colfname.includes(this.state.searchSurname.toLowerCase())){

return (
  <div key={i}
  style={{borderBottom:'1px solid black', margin:'10px', color:'white'}}>

<button onClick={() => this.setColNo(collector.code, collector.cell)}>
  <p>Name: {collector.name}</p>
  <p>Surname: {collector.surname}</p>
  <p>ID No: {collector.code}</p>
</button>

  </div>
)
}
else{
  return null;
}



})








return(



!this.props.isAuthed ? <h1> not authenticated </h1>


:(
  !this.state.part2 ?
<div className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100,backgroundColor:'white'}}>

  <h1> Change Child Details </h1>

<div>
  <label htmlFor="childName" style={{marginRight:40}}>
  Child Name</label>
  <input
  type="text"
  placeholder="Child Name"
  id="childName"
  className="pa2 ma2"
  onKeyUp={this.changeChildName}
  />
  <br/>

  <label htmlFor="childSurname" style={{marginRight:21}}>
  Child Surname</label>
  <input
  type="text"
  placeholder="Child Surname"
  id="childSurname"
  className="pa2 ma2"
  onKeyUp={this.changeChildSurname}
  />
  <br/>

  <button className="br3 ma2 pa3 bg-blue br-blue" onClick={this.changeToPart2}>Continue</button>
</div>


  </div> :

  <div>


    <div style={{margin:100}}className={this.state.searchShow} scroll="true">

  <div style={{display:'flex', flexDirection:'row'}}>
    <input type="text" placeholder="Please Enter Surname" onKeyUp={this.onSearchSurname}/>
    <button onClick={this.doSearch}><FontAwesomeIcon icon={faSearch} /></button>
    </div>
  <div style={{display:'flex',flexDirection:'row wrap', overflow:'scroll'}}>
    {searchResults}
  </div>
  </div>



  {child}
  </div>
)







)

}

}


export default ChangeChildDetails;



// WEBPACK FOOTER //
// ./src/components/ChangeChildDetails/ChangeChildDetails.js